import { message } from "antd";

export const handleCopy = (text) => {
  navigator.clipboard.writeText(text);
  message.success("Code Saved To Clipboard");
};
